<template>
  <div class="container-fluid">
    <tab></tab>
    <neck ref="neck"></neck>

    <div class="hidden-xs hidden-sm">
      <div class="web-index-foot">
        <div class="index-foot-title middle">&nbsp;</div>

        <div class="index-foot-center spaceBetween wrap">
          <div class="foot-center-li" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageList" :key="index">
            <div class="center-li-top">
              <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="center-li-img"/>
              <!-- <div class="li-top-center"><a target="/campaign">蔬适活动</a></div> -->
            </div>
            <div class="center-li-center">
              <div class="li-center-label">{{item.start_time}}</div>
              <div class="li-center-title fontHidden">{{type==1?item.title_zh:item.title}}</div>
              <div class="li-center-font">{{type==1?item.summary_zh:item.summary}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-foot">

        <div class="index-foot-center spaceBetween wrap">
          <div class="foot-center-liPhone" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageList" :key="index">
            <div class="center-li-top">
              <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="center-li-img"/>
              <!-- <div class="li-top-center"><a target="/campaign">蔬适活动</a></div> -->
            </div>
            <div class="center-li-center">
              <div class="li-center-label">{{item.start_time}}</div>
              <div class="li-center-title fontHidden">{{type==1?item.title_zh:item.title}}</div>
              <div class="li-center-font">{{type==1?item.summary_zh:item.summary}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab.vue'
import neck from '@/components/neck.vue'
import footerBar from '@/components/footerBar.vue'
import axios from 'axios'
import {format} from '@/utils/util.js'
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar,
    neck:neck
  },
  data () {
    return {
      page:1,
      type:1,
      pageList:[]
    }
  },
  methods:{
    windowOpen(url_type,url,id){
      const vm=this
      if(url_type==0){
        vm.$router.push({path: '/news',query:{id:id}});
        //window.open('/news/'+id);
      }else{
        window.open(url);
      }      
    },
    queryNewsList(){
      const vm=this
      let obj = {
        category_id:3,
      }
      axios.post(`${vm.global.urlInfo.queryUrl}/api/monday/news_list`,obj).then(data=>{
        if(data&&data.data&&data.data.code==1){
          data.data.data.data.forEach(da=>{
            da.start_time=format(new Date(da.start_time),'YYYY.MM.DD')
            da.summary_zh = da.summary_zh&&da.summary_zh.length>32?da.summary_zh.slice(0,32)+'...':da.summary_zh
            da.summary = da.summary&&da.summary.length>32?da.summary.slice(0,32)+'...':da.summary
          })
          vm.pageList = data.data.data.data
        }
      })
    },
    choiceType(num){
      const vm=this
      vm.type = localStorage.getItem('ssType') || Number(num)
      vm.$refs.neck.setType(vm.type,3)
      vm.$refs.neck.setPageTips({
        site_name:'蔬适周一，舒适一周！',
        site_name_en:'蔬适周一，舒适一周！',
      })
      vm.$refs.footerView.setType(vm.type)
    }
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.choiceType(1)
    vm.queryNewsList()
  }
}
</script>
<style scoped>
/**  首页banner web  **/
.container-fluid{
  width: 100%;
  padding: 0;
  margin: 0;
}

/**  首页  项目介绍  **/
.web-index-middle{
  padding: 0.75rem 0.5rem 0.625rem;
  height: auto;
  background: #f5f8ef;
}
.web-middle-center{
  width: 100%;
  height: 3.75rem;
  background: #fff;
  border-radius: 10px;
}
.web-center-img{
  height: 3.75rem;
  width: auto;
  border-radius: 10px 0 0 10px;
}
.web-center-center{
  border-radius: 0 10px 10px 0;
  height: 3.75rem;
  flex: 2;
}
.center-center-view{
  padding: 0.375rem 0.625rem;
  height: 100%;
  overflow: hidden;
}
.center-view-title{
  font-size: 0.225rem;
  color: #365b3a;
  width: 100%;
  text-align: left;
  line-height: 1;
  margin-bottom: 0.2875rem;
  font-family: 'huangyou';
}
.center-view-font{
  font-size: 0.1rem;
  color: #59625a;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.25rem;
  letter-spacing: 2px;
}

/**  首页  项目介绍 phone  **/
.phone-index-middle{
  padding: 1rem 0.4rem;
  height: auto;
  background: #f5f8ef;
}
.phone-middle-top{
  width: 100%;
  height: auto;
  border-radius: 10px 10px 0 0;
}
.phone-middle-center{
  padding: 0.8rem 0.6rem;
  height: auto;
  background: #fff;
  border-radius: 0 0 10px 10px;
}
.phone-center-view{
  padding: 0.375rem 0.625rem;
  height: 100%;
  overflow: hidden;
  
}
.phone-view-title{
  font-size: 0.52rem;
  color: #365b3a;
  width: 100%;
  text-align: left;
  line-height: 1;
  margin-bottom: 0.2875rem;
}
.phone-view-font{
  font-size: 0.32rem;
  color: #59625a;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.25rem;
  letter-spacing: 2px;
}

/**  首页  视频  **/
.web-index-body{
  width: 100%;
  height: 5.625rem;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
}
.index-body-img{
  width: 100%;
  height: 100%;
  display: inline-block;
  line-height: 0;
}

/**  首页  视频  phone  **/
.phone-index-body{
  width: 100%;
  height: auto;
}
.phone-body-img{
  width: 100%;
  height: auto;
}


/**  首页  申请  **/
.web-index-leg{
  padding: 0.625rem 0.5rem 0.25rem;
  height: auto;
  background: #f5f8ef;
}
.index-leg-list{
  width: 49%;
  height: 3.75rem;
  border-radius: 12px;
  background: #fff;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.leg-list-img{
  width: 100%;
  height: 100%;
  display: inline-block;
  line-height: 0;
}
.leg-list-center{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.list-center-view{
  padding: 0.225rem 0.25rem 0.375rem;
  height: 100%;
}
.center-view-title{
  width: 100%;
  height: auto;
  line-height: 1;
  font-size: 0.225rem;
  color: #708d4b;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.center-view-tips{
  font-size: 0.1rem;
  color: #5a625a;
  line-height: 1;
  text-align: center;
  margin-bottom: 0.1rem;
}
.center-view-list{
  width: 100%;
  height: auto;
  padding-top: 0.125rem;
  
}
.view-list-li{
  width: 48%;
  height: 0.3125rem;
  border: 1px solid #bfc4b8;
  border-radius: 6px;
  background: #fff;
}
.list-li-center{
  padding: 0 0.125rem;
  height: 0.3125rem;
}
.li-center-img{
  width: auto;
  height: 0.15rem;
}
.li-center-input{
  flex: 2;
  height: auto;
  margin-left: 0.125rem;
  font-size: 0.1125rem;
  color: #365b3a;
  border: none;
  background: none;
}
input::placeholder{
  font-size: 0.1125rem;
  color: #779253;
}
.center-view-bottom,.center-right-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.125rem;
}
.view-bottom-bnt{
  width: 1.25rem;
  height: 0.3125rem;
  background: #708d4b;
  border-radius: 0.3125rem;
  font-size: 0.125rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.3125rem;
  cursor: pointer;
}
.view-right-bnt{
  height: 0.5rem;
  width: 2.5rem;
  background: #708d4b;
  border-radius: 0.5rem;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.5rem;
  cursor: pointer;
}

/**  首页  申请  phone  **/
.phone-index-leg{
  padding: 0.8rem 0.2rem;
  height: auto;
  background: #f5f8ef;
}
.phone-leg-list{
  width: 100%;
  height: 13.8rem;
  margin-bottom: 0.32rem;
  border-radius: 12px;
  background: #fff;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.center-view-titlePhone{
  width: 100%;
  height: auto;
  line-height: 1;
  font-size: 0.52rem;
  color: #708d4b;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.25rem;
  padding-top: 0.25rem;
}
.center-view-tipsPhone{
  font-size: 0.32rem;
  color: #5a625a;
  line-height: 1;
  text-align: center;
  margin-bottom: 0.2rem;
}
.list-li-centerPhone{
  padding: 0 0.25rem;
  height: 100%;
}
.view-list-liPhone{
  width: 100%;
  height: 1rem;
  margin-bottom: 0.4rem;
  border: 1px solid #bfc4b8;
  border-radius: 6px;
  background: #fff;
}
.li-center-imgPhone{
  width: auto;
  height: 0.6rem;
}
.li-center-inputPhone{
  flex: 2;
  height: auto;
  margin-left: 0.25rem;
  font-size: 0.48rem;
  color: #365b3a;
  border: none;
  background: none;
}
.li-center-inputPhone::placeholder{
  font-size: 0.48rem;
  color: #779253;
}
.center-view-bottomPhone{
  width: 100%;
  height: auto;
  margin-top: 0.4rem;
}
.view-bottom-bntPhone{
  height: 0.8rem;
  width: 2.8rem;
  background: #708d4b;
  border-radius: 0.5rem;
  font-size: 0.35rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.8rem;
}
.center-right-bottomPhone{
  width: 100%;
  height: auto;
  padding-top: 0.8rem;
}
.view-right-bntPhone{
  height: 1rem;
  width: 5.6rem;
  background: #708d4b;
  border-radius: 1rem;
  font-size: 0.42rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 1rem;
}

/**  首页  新闻  **/
.web-index-foot{
  padding: 0.35rem 0.5rem 0.15rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-title{
  font-size: 0.3rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.index-foot-center{
  width: 100%;
  height: auto;
}
.foot-center-li{
  width: 2.075rem;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  margin-bottom:0.3rem
}
.center-li-top{
  width: auto;
  height: auto;
  position: relative;
}
.center-li-img{
  width: 100%;
  height: auto;
  border-radius: 8px 8px 0 0;
}
.li-top-center{
  padding: 0.0625rem 0.1rem;
  font-size: 0.1125rem;
  color: #fff;
  line-height: 1;
  background: #e4a169;
  position: absolute;
  top: 0;
  left: 0.1875rem;
  border-radius: 0 0 6px 6px;
  
}
.center-li-center{
  height: auto;
  padding: 0.125rem 0.1625rem 0.2125rem;
  background: #fff;
  border-radius: 0 0 8px 8px;
}
.li-center-label{
  font-size: 0.0935rem;
  color: #728b4a;
  line-height: 1;
  margin-bottom: 0.125rem;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.li-center-title{
  font-size: 0.1125rem;
  color: #365b3a;
  font-weight: 600;
  text-align: left;
  letter-spacing: 2px;
  line-height: 1;
  margin-bottom: 0.1375rem;
  font-family: "Times New Roman", Times, serif;
}
.li-center-font{
  font-size: 0.0935rem;
  color: #5a625a;
  line-height: 1.6;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.index-foot-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.25rem;
  padding-bottom: 0.375rem;
}
.foot-bottom-btn{
  width: 1rem;
  height: 0.25rem;
  border: 1px solid #365b3a;
  border-radius: 0.25rem;
  color: #365b3a;
  font-size: 0.1125rem;
  line-height: 0.25rem;
  font-family: "Times New Roman", Times, serif;
  cursor: pointer;
}
.index-foot-bottomPhone{
  width: 100%;
  height: auto;
  padding-top: 0.25rem;
}

/**  首页  新闻 phone  **/
.phone-index-foot{
  padding: 0.8rem 0.2rem 0.6rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-titlePhone{
  font-size: 0.52rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.foot-center-liPhone{
  width: 48%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 0.32rem;
}
.foot-bottom-btnPhone{
  width: 2.6rem;
  height: 0.6rem;
  border: 1px solid #365b3a;
  border-radius: 0.6rem;
  color: #365b3a;
  font-size: 0.32rem;
  line-height: 0.6rem;
  font-family: "Times New Roman", Times, serif;
}

.phone-center-list{
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  font-size: 0.36rem;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  background: rgba(220,155,97,0.95);
  position: relative;
}

</style>

